export default __webpack_public_path__ + "static/media/logo.eb24ae08.jpg";